import { mutationTree } from 'typed-vuex'
import { Vue } from 'vue-property-decorator'
import { setState } from '~/lib/utils/store'

export type Reaction = '👏' | '🎉' | '❤️' | '👀' | '🔥'

export const state = () => ({
  winnerBlastDismissed: false,
  winnerBlastLastSeenWinner: null,
  winnerBlastReactions: {} as Record<string, Reaction>
})

export const mutations = mutationTree(state, {
  setState,

  saveReaction(state, { id, reaction }) {
    Vue.set(state.winnerBlastReactions, id, reaction)
  }
})
